import React, { useState } from "react";
import API from "../../api/axiosInstance";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../css/AddRoom.css";
import AmenitiesList from "./AmenitiesList";
import { ROOM_TYPES } from "../../constants/roomConfig";

const pickerDateToKey = (d) => {
  if (!d) return null;
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const AddRoom = ({ selectedHotel, onAdded, onClose }) => {
  const [form, setForm] = useState({
    hotel_id: selectedHotel?._id ? [selectedHotel._id] : [],
    room_name: "",
    room_type: "",
    price: "",
    no_of_rooms: "",
    bed_count: "1",
    amenities: [],
    from_date: null,
    to_date: null,
  });


  const hotelDisplayName =
    selectedHotel?.global_hotel_id?.global_hotel_name ||
    selectedHotel?.global_hotel_name ||
    "N/A";

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.hotel_id.length) {
      alert("Hotel ID is missing!");
      return;
    }

    const fromKey = pickerDateToKey(form.from_date);
    const toKey = pickerDateToKey(form.to_date);
    if (fromKey && toKey && toKey < fromKey) {
      alert("Available To date cannot be before Available From date.");
      return;
    }

    try {
      const payload = {
        ...form,
        bed_count: Math.max(1, parseInt(form.bed_count, 10) || 1),
        from_date: fromKey,
        to_date: toKey,
      };
      await API.post('/ems/rooms', payload);
      alert("Room added successfully!");
      onAdded();
      onClose();
    } catch (err) {
      console.error("Add Room Error:", err);
      alert(err.response?.data?.message || err.message);
    }
  };

  return (
    <div
      className="modal show d-block"
      style={{ background: "rgba(0,0,0,0.4)" }}
    >
      <div className="modal-dialog modal-md add-room-modal">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Add Room Type</h5>
            <p className="add-room-subtitle">
              Add a new room type to <strong>{hotelDisplayName}</strong>
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="modal-body add-room-body">
              {/* ROOM NAME */}
              <div className="mb-3">
                <label className="form-label">Room Name <span className="text-danger">*</span></label>
                <input
                  type="text"
                  name="room_name"
                  className="form-control"
                  placeholder="Enter room name"
                  value={form.room_name}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* ✅ ROOM TYPE DROPDOWN */}
              <div className="mb-3">
                <label className="form-label">Room Type <span className="text-danger">*</span></label>
                <select
                  name="room_type"
                  className="form-control"
                  value={form.room_type}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select room type</option>
                  {ROOM_TYPES.map((rt) => (
                    <option key={rt} value={rt}>{rt}</option>
                  ))}
                </select>
              </div>

              {/* PRICE */}
              <div className="mb-3">
                <label className="form-label">Price Per Night <span className="text-danger">*</span></label>
                <input
                  type="number"
                  name="price"
                  className="form-control"
                  placeholder="e.g. 100"
                  value={form.price}
                  onChange={handleChange}
                  style={{ MozAppearance: 'textfield' }}
                  onWheel={(e) => e.target.blur()}
                  required
                />
              </div>

              {/* NO OF ROOMS */}
              <div className="mb-3">
                <label className="form-label">Total Rooms Available <span className="text-danger">*</span></label>
                <input
                  type="number"
                  name="no_of_rooms"
                  className="form-control"
                  placeholder="Number of rooms"
                  value={form.no_of_rooms}
                  onChange={handleChange}
                  onWheel={(e) => e.target.blur()}
                  required
                />
              </div>

              {/* NUMBER OF BEDS */}
              <div className="mb-3">
                <label className="form-label">Number of beds per room <span className="text-danger">*</span></label>
                <input
                  type="number"
                  name="bed_count"
                  className="form-control"
                  placeholder="1"
                  min={1}
                  max={10}
                  value={form.bed_count}
                  onChange={handleChange}
                  onWheel={(e) => e.target.blur()}
                  required
                />
              </div>

              <AmenitiesList
                amenities={form.amenities}
                onChange={(a) => setForm({ ...form, amenities: a })}
              />

              {/* DATES */}
              <div className="row">
                <div className="col">
                  <label className="form-label d-block">Available From <span className="text-danger">*</span></label>
                  <DatePicker
                    selected={form.from_date}
                    onChange={(date) => {
                      const toKey = form.to_date ? pickerDateToKey(form.to_date) : null;
                      const fromKey = date ? pickerDateToKey(date) : null;
                      const clearTo = fromKey && toKey && toKey < fromKey;
                      setForm({
                        ...form,
                        from_date: date,
                        ...(clearTo ? { to_date: null } : {}),
                      });
                    }}
                    className="form-control w-100"
                    dateFormat="dd-MMM-yyyy"
                    placeholderText="Select date"
                    required
                  />
                </div>

                <div className="col">
                  <label className="form-label d-block">Available To <span className="text-danger">*</span></label>
                  <DatePicker
                    selected={form.to_date}
                    onChange={(date) =>
                      setForm({ ...form, to_date: date })
                    }
                    minDate={form.from_date}
                    className="form-control w-100"
                    dateFormat="dd-MMM-yyyy"
                    placeholderText="Select date"
                    required
                  />
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="submit"
                className="btn"
                style={{ background: "#D9A128", color: "#fff" }}
              >
                Add Room
              </button>
              <button
                type="button"
                className="btn"
                onClick={onClose}
                style={{ background: "#000", color: "#fff" }}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddRoom;
